import React from 'react';
import PropTypes from 'prop-types';
const ImageElement = ({src, className = '', ...ImgProps}) => (
  <img className={className + ' lazyload'} data-src={src} {...ImgProps} />
);
ImageElement.displayName = 'ImageElement';
ImageElement.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
};
export default ImageElement;



// WEBPACK FOOTER //
// ./src/components/ImageElement.js